import getBackendUrl from './getBackendURL';

let language = document.querySelector('body')?.getAttribute('lang') || document.querySelector('html')?.getAttribute('lang')
if (!language) {
  language = 'en'
}

const url = getBackendUrl()+'services/shippingInfo/list';

const getCountries = async () => {
  const endpoint = `${url}/${language}`
  const response = await fetch(endpoint, { method: 'GET' })
  const result = await response.json()
  return result;
}

export default getCountries;
